function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0081 19C8.13765 19 5 15.8623 5 11.9919C5 9.69479 6.10879 7.64622 7.82757 6.36602C7.78024 6.73514 7.75611 7.10967 7.75611 7.48778C7.75611 12.3236 11.6764 16.2439 16.5122 16.2439C16.8903 16.2439 17.2649 16.2198 17.634 16.1724C16.3538 17.8912 14.3052 19 12.0081 19ZM3 11.9919C3 16.9669 7.03308 21 12.0081 21C16.7998 21 20.7176 17.2588 21 12.5381C19.8067 13.5993 18.2347 14.2439 16.5122 14.2439C12.7809 14.2439 9.75611 11.2191 9.75611 7.48778C9.75611 5.76527 10.4007 4.19332 11.4619 3C6.74119 3.28237 3 7.20021 3 11.9919ZM17 4.17157L14.1716 7L17 9.82843L19.8284 7L17 4.17157Z",
  fill: "black"
});

var SvgDark = function SvgDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark.39d93199.svg";
export { ForwardRef as ReactComponent };